/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: routes.ts
 * Class: routes.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

enum RouteNames {
  NotFound = 'Not Found',
  StepOneRoute = 'Step One',
  StepTwoRoute = 'Step Two',
  StepThreeRoute = 'Step Three',
  StepFourRoute = 'Step Four',
  PaymentPendingRoute = 'Payment Pending',
  OrderProcessRoute = 'Order Process',
  DonationRoute = 'Donation',
  NewsOverviewRoute = 'News Overview',
  NewsDetailRoute = 'News Detail',
  TextRoute = 'Text Page',
  ServerStatusRoute = 'Server Status',
  ServerSettingsRoute = 'Server Settings',
  ServerContentRoute = 'Server Content',
  ServerAdministrationRoute = 'Server Administration',
  GameserverProductsRoute = 'Gameserver Overview',
  CreatorBundlesRoute = 'Creator Bundles Overview',
  EpsGameserverOverview = 'EPS Gameservers Overview',
  GamecloudDashboardRoute = 'Gamecloud Dashboard',
  GamecloudDashboardAddRoute = 'Gamecloud Dashboard Add Game',
  ProfileRoute = 'Profile',
  HomepageRoute = 'Homepage',
  ProfilePaymentTransactionRoute = 'Transactions',
  ProfilePaymentRecurringRoute = 'Payment Method',
  ProfilePaymentManageRoute = 'Cancellation',
  SupportRoute = 'Support',
  LandingpageRoute = 'Landingpage',
  ProfilePaymentInvoicesRoute = 'Invoices',
  ServerRoute = 'Server',
  ReferrerRoute = 'Referrer Panel'
}

export default RouteNames;
